import { Component, OnInit } from '@angular/core';
import { CtDatatableResult, CtSearchFiltersConfiguration, SnackbarService } from '@ctsolution/ct-framework';
import { CtSerializerHelperService, CtWebapiGenericResponse, CtWebapiService, DataRequest } from '@ctsolution/ct-webapi';
import { CartOrderConfiguration } from 'src/app/_components/cart-order/cart-order.configuration';
import { Flow } from 'src/app/core/classes/flow';
import { FlowListFilters, FlowListParameter } from 'src/app/core/classes/flow-list.parameter';
import { FlowController } from 'src/app/core/controllers/flow.controller';
import { FLOW_STATE } from 'src/app/core/enums/flow-state';
import { FileService } from 'src/app/core/lib/file.service';
import { FlowService } from 'src/app/core/lib/flow.service';
import { GeneralService } from 'src/app/core/lib/general.service';
import { JwtService } from 'src/app/core/lib/jwt.service';
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { ToSignUploadComponent } from './to-sign-upload/to-sign-upload.component';

@Component({
  selector: 'app-to-sign',
  templateUrl: './to-sign.component.html',
  styleUrls: ['./to-sign.component.scss']
})
export class ToSignComponent implements OnInit {

  filtersConfiguration: CtSearchFiltersConfiguration = CtSearchFiltersConfiguration.create().setFilters(FlowListFilters);

  items: CartOrderConfiguration[] = [];

  params: FlowListParameter = new FlowListParameter();

  hasQuoteApprover: boolean = false;

  filter(event: any) {

    this.params = event ?? {};

    this.fetch();

  }

  createToSignOrder = (flow: Flow) =>
    CartOrderConfiguration.create()
      .manageEstimatedPrice(true)
      .manageToSign(true)
      .setFlow(flow);

  constructor(
    private flowController: FlowController,
    private _general: GeneralService,
    private _jwt: JwtService,
    private flowService: FlowService,
    private fileService : FileService,
    private _webapi : CtWebapiService,
    private serializerHelperService : CtSerializerHelperService,
    private dialog: MatDialog,
    private snackBar : SnackbarService
    
  ) { }

  ngOnInit() {

    this.setup();
  }

  async setup() {

    const autoAcceptPrintQuote = await this._jwt.getAutoAcceptPrintQuote();

    if (autoAcceptPrintQuote) {

      this._general.navigateTo(["/carrello"]);

    } else {

      this.fetch();

    }

  }

    fetch() {
  
      this.params.FlowStates = [FLOW_STATE.TO_SIGN];
  
      this.flowController
        .list(this.params)
        .then((result: CtDatatableResult<Flow>) => {
  
          this.items = result.Items.map((flow: Flow) => this.createToSignOrder(flow));
  
        });
  
        this.flowService.getToSignCount();
  
    }

   downloadZip(){

      this.fileService.downloadFlowFilesZip().then((result : any) => {});
      
    }

    uploadZip(value : File) : Promise<any>{


      return new Promise<any>((resolve) => {

        const flowOids: Array<number> = this.items.map(item => item.flow.Oid)

        let parameter = {
          FlowOids: flowOids,
          File: value
        }

        // @ts-ignore
        parameter = this.serializerHelperService.objectToFormData(parameter);

        const request: DataRequest = new DataRequest(`/FlowFile/UploadFlowFilesZip`);
  
        this._webapi
          .post(request, parameter)
          .subscribe((r: CtWebapiGenericResponse<any>) =>{

            this.snackBar.open('Caricamento firme avvenuta con successo');
            this.fetch();
            this.flowService.getToSignCount();
            this.flowService.getCartCount();
            resolve(r.Result);

          })
  
      });
  
    }

    openUploadDialog(){

      this.dialog.open(ToSignUploadComponent,{disableClose: true}).afterClosed().subscribe((response : any) => {

        if(response && response.length > 0){

          this.uploadZip(response[0])  

        }


      })

    }

}